/**
 * Consistency · variantstyrd visning
 *
 * ALEXANDER 2026-08-26: näringsvärde, innehållsförteckning, säljtext och
 * USP:ar ska visa den smak kunden valt, ingen annan.
 *
 * Alla varianter ligger i HTML:en, dolda med hidden. Sökmotorer och AI-svar
 * läser därför hela innehållsförteckningen för samtliga smaker utan att
 * något behöver klickas fram, medan kunden bara ser sin egen.
 *
 * Blocket äger INTE varianttillståndet. Horizons egen variant-picker räknar
 * fortfarande pris, lager och galleribild. Vi läser bara vilken radioknapp
 * som är ikryssad och speglar det. Samma hållning som con-smakval.
 *
 * Utan JavaScript står första varianten framme och den riktiga väljaren är
 * en länk till ?variant=, alltså laddar sidan om med rätt panel serverrenderad.
 *
 * Horizon kan rendera om produktinformationen vid variantbyte. Därför körs
 * synkroniseringen även när DOM ändras, och funktionen är idempotent.
 */

(function () {
  'use strict';

  function valdVariant() {
    var kryssad = document.querySelector(
      'variant-picker input[type="radio"]:checked, .variant-picker input[type="radio"]:checked'
    );
    if (kryssad && kryssad.value) return kryssad.value;

    // Fallback: smakvalsblocket vet vad som är markerat även innan
    // väljaren hunnit renderas om.
    var val = document.querySelector('.con-smakval__val--vald');
    if (val) return val.getAttribute('data-varde');

    return null;
  }

  function visa(varde) {
    if (!varde) return;
    var paneler = document.querySelectorAll('[data-con-variant]');
    if (!paneler.length) return;

    for (var i = 0; i < paneler.length; i++) {
      var p = paneler[i];
      if (p.getAttribute('data-con-variant') === varde) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    }
  }

  function synka() {
    visa(valdVariant());
  }

  // Klick i con-smakval kryssar i den riktiga radioknappen och den
  // dispatchar change, som bubblar hit.
  document.addEventListener('change', function (e) {
    var mal = e.target;
    if (!mal || mal.type !== 'radio') return;
    window.requestAnimationFrame(synka);
  });

  // Horizon kan byta variant via history state (?variant= i adressfältet).
  window.addEventListener('popstate', function () {
    window.requestAnimationFrame(synka);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synka);
  } else {
    synka();
  }

  // Renderar Horizon om köpblocket serverrenderas rätt panel fram av sig
  // själv, men con-fakta ligger i en EGEN sektion och renderas aldrig om.
  // Därför speglas valet igen så fort något i dokumentet ändras.
  var vantar = false;
  new MutationObserver(function (poster) {
    if (vantar) return;
    if (!poster.some(function (p) { return p.addedNodes.length > 0; })) return;
    vantar = true;
    window.requestAnimationFrame(function () {
      vantar = false;
      synka();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
